import { getTNCConfigByType } from '@/api';


export async function getTNCConfig(type: string, tncId: string) {
  const tncConfigs = await getTNCConfigByType(type);
  return tncConfigs.filter(({ tncId: id }) => tncId === id)[0];
}
